export const groupByOptions = [
  { value: 0, label: 'Site' },
  { value: 1, label: 'Order #' },
  { value: 2, label: 'Item Code' },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/openordersreport/helper/index.js